module.exports = __webpack_public_path__ + "media/icons/star-a05db16c.svg";